import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const measureListRoutes = {
  path: 'measure-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.measure.list'),
  },
  children: [
    {
      path: '',
      name: 'measureList',
      component: () => lazyLoadView(import('@views/MeasureList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: ':id',
      name: 'measureDetail',
      component: () => lazyLoadView(import('@views/MeasureList/detail.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.measure.detail'),
      },
    },
  ],
}

export default measureListRoutes
